import {
	NewsLetterDetailsadded,
	NewsLetterSubscribe,
	NewsLetterUnsubscribe,
} from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class NewsletterSubscriptions<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags Newsletter subscriptions
	 * @name NewsLetterSubscriptionAddNewsLetterDetailsCreate
	 * @summary Subscribe a user for news letter subscriptions..
	 * @request POST:/store/{storeId}/news_letter_subscription/add_news_letter_details
	 * @secure
	 * @response `200` `NewsLetterDetailsadded` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	newsLetterSubscriptionAddNewsLetterDetailsCreate = (
		storeId: string,
		query?: {
			/** The e-mail address to be added for news letter subscription. */
			emailId?: string;
			/** The language ID. */
			langId?: string;
			/** flag to notify the request is from Ruby store. */
			x_rubyStore?: boolean;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails ||
				this.http.traceDetails['newsLetterSubscriptionAddNewsLetterDetailsCreate'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/news_letter_subscription/add_news_letter_details`,
				params: _params,
				query: query,
				methodName: 'newsLetterSubscriptionAddNewsLetterDetailsCreate',
			};
			logger.trace(traceData);
		}
		return this.http.request<NewsLetterDetailsadded, void>({
			path: `/store/${storeId}/news_letter_subscription/add_news_letter_details`,
			method: 'POST',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
	 * No description
	 *
	 * @tags Newsletter subscriptions
	 * @name NewsLetterSubscriptionSubscribeCreate
	 * @summary Subscribe news letter for the given user id and email id..
	 * @request POST:/store/{storeId}/news_letter_subscription/subscribe
	 * @secure
	 * @response `200` `NewsLetterSubscribe` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	newsLetterSubscriptionSubscribeCreate = (
		storeId: string,
		query?: {
			/** The language ID. */
			langId?: string;
			/** The e-mail address to be added for news letter subscription. */
			emailId?: string;
			/** The contactListId. */
			contactListId?: string;
			/** flag to notify the request is from Ruby store. */
			x_rubyStore?: boolean;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['newsLetterSubscriptionSubscribeCreate'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/news_letter_subscription/subscribe`,
				params: _params,
				query: query,
				methodName: 'newsLetterSubscriptionSubscribeCreate',
			};
			logger.trace(traceData);
		}
		return this.http.request<NewsLetterSubscribe, void>({
			path: `/store/${storeId}/news_letter_subscription/subscribe`,
			method: 'POST',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
	 * No description
	 *
	 * @tags Newsletter subscriptions
	 * @name NewsLetterSubscriptionUnsubscribeCreate
	 * @summary unSubscribe news letter for the given user id and email id..
	 * @request POST:/store/{storeId}/news_letter_subscription/unsubscribe
	 * @secure
	 * @response `200` `NewsLetterUnsubscribe` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	newsLetterSubscriptionUnsubscribeCreate = (
		storeId: string,
		query?: {
			/** The e-mail address to be added for news letter subscription. */
			emailId?: string;
			/** The language ID. */
			langId?: string;
			/** The contactListId. */
			contactListId?: string;
			/** flag to notify the request is from Ruby store. */
			x_rubyStore?: boolean;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['newsLetterSubscriptionUnsubscribeCreate'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/news_letter_subscription/unsubscribe`,
				params: _params,
				query: query,
				methodName: 'newsLetterSubscriptionUnsubscribeCreate',
			};
			logger.trace(traceData);
		}
		return this.http.request<NewsLetterUnsubscribe, void>({
			path: `/store/${storeId}/news_letter_subscription/unsubscribe`,
			method: 'POST',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
